import { NgModule } from '@angular/core';
import { ComparisonDataAccessModule } from '@comparison/data-access';
import { ComparisonFeatureModule } from '@comparison/feature';
import { ComparisonUiModule } from '@sdvor/comparison/ui';

@NgModule({
  imports: [ComparisonDataAccessModule, ComparisonFeatureModule, ComparisonUiModule],
})
export class SdvorComparisonShellModule {}
